<pw-view-title>
  {{'change.indexNumber.indexStates' | translate}} {{(construction$ | async)?.NAME}}
</pw-view-title>

<div class="ps-flex-container-col">
  <mat-form-field>
    <mat-select placeholder="{{'change.indexNumber.selectIndex' | translate}}" [(value)]="selectedIndex"
                (valueChange)="onChangeIndex($event)">
      <mat-option *ngFor="let index of indices$ | async" [value]="index">
        {{index.NAME}} - {{index.INDEX_ZI}}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field>
    <input matInput placeholder="Filter..." [formControl]="searchFormControl"/>
  </mat-form-field>

  <div style="justify-self: end">
    <button mat-raised-button color="primary" *ngIf="selectedIndex" style="margin-right: 12px"
            routerLink="/pm-constructions/{{route.snapshot.params.constructionId}}/pm-indices/{{selectedIndex?.OBJECT_ID}}/prisma/import">
      {{'change.indexNumber.importIndexNumber' | translate}}
    </button>
    <button mat-raised-button color="primary" *ngIf="selectedIndex" (click)="deleteIndex(selectedIndex)" style="margin-right: 12px">
      INDEX LÖSCHEN
    </button>
    <button mat-raised-button color="primary" (click)="createIndex()">
      INDEX ANLEGEN
    </button>
  </div>

  <mat-tab-group>
    <mat-tab label="Sachnummern">
      <div class="ps-grid-3-col" style="margin-top: 8px" *ngIf="snrs$ | async as loadedSnrs; else noParts">
        <mat-card *ngFor="let snr of loadedSnrs" style="padding: 12px">
          <mat-card-title>
            <img class="mat-icon" src="{{snr.ICON_URL}}"/>
            {{snr.NAME}}
          </mat-card-title>
          <mat-card-content>
            <div class="ps-grid-2-col">
              <div>
                <div>ZI: {{snr.INDEX_ZI}}</div>
                <div>Beschreibung: {{snr.DESCRIPTION}}</div>
              </div>
              <div>
                <div>Typ: {{snr.PM_DOKU_TYP}}</div>
                <div>Format: {{snr.PM_DOKU_FORMAT}}</div>
              </div>
            </div>
          </mat-card-content>
          <mat-card-actions align="end">
            <button mat-button color="primary"
                    routerLink="/pm-constructions/{{route.snapshot.params.constructionId}}/pm-indices/{{selectedIndex.OBJECT_ID}}/snrs/{{snr.OBJECT_ID}}/documents">
              DOKUMENTE
            </button>
            <button mat-button color="primary"
                    routerLink="/pm-constructions/{{route.snapshot.params.constructionId}}/pm-indices/{{selectedIndex.OBJECT_ID}}/prisma/import/{{snr.OBJECT_ID}}">
              DOKUMENTIMPORT
            </button>
            <button mat-button color="primary" (click)="deleteSnr(snr)">
              LÖSCHEN
            </button>
          </mat-card-actions>
        </mat-card>

      </div>
      <ng-template #noParts>
        Keine Sachnummern gefunden / Bitte einen Index auswählen!
      </ng-template>
    </mat-tab>

    <mat-tab label="Kommentare">
      <ng-container *ngIf="comments$ | async as comments">
        <div class="comments-container" style="margin-top: 8px">
          <div *ngFor="let comment of comments" class="comment"
               [class]="getAuthorClass(comment)">
            <div class="comment-author">{{comment.USERNAME}} <span
              style="font-weight: normal"> - {{comment.DATUMERSTELLUNG | date: 'short'}}</span>
            </div>
            <mat-divider style="margin: 8px"></mat-divider>
            <div class="comment-text">{{comment.COMMENT}}</div>
          </div>
        </div>
      </ng-container>
      <div class="ps-flex-container-col"
           style="justify-items: end; justify-content: end; align-items: end; align-content: end">
        <button mat-raised-button color="accent" (click)="createComment()">
          KOMMENTAR HINZUFÜGEN
        </button>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
